import { useCallback, useEffect, useRef, useState } from "react";

const KEY = "qtv_autoplay";

export const useAutoplayPref = () => {
  const [on, setOn] = useState(() => localStorage.getItem(KEY) !== "off");
  const set = useCallback((v) => {
    localStorage.setItem(KEY, v ? "on" : "off");
    setOn(v);
  }, []);
  return [on, set];
};

// Listens to a YouTube iframe (enablejsapi=1): onEnded() when playback finishes, onTime(seconds, duration) as it plays.
export const useYouTubeEvents = (iframeRef, handlers, enabled = true, frameKey = null) => {
  const cb = useRef(handlers);
  cb.current = handlers;
  const duration = useRef(0);

  useEffect(() => {
    const frame = iframeRef.current;
    duration.current = 0;
    if (!enabled || !frame) return;
    const listen = () => {
      frame.contentWindow?.postMessage(JSON.stringify({ event: "listening", id: 1, channel: "widget" }), "*");
    };
    const onMsg = (e) => {
      if (e.source !== frame.contentWindow || !/^https:\/\/(www\.)?youtube(-nocookie)?\.com$/.test(e.origin)) return;
      let d = e.data;
      if (typeof d === "string") {
        try { d = JSON.parse(d); } catch { return; }
      }
      const state = d?.event === "onStateChange" ? d.info : d?.info?.playerState;
      if (d?.info?.duration) duration.current = d.info.duration;
      if (typeof d?.info?.currentTime === "number") cb.current.onTime?.(d.info.currentTime, duration.current);
      if (state === 0) cb.current.onEnded?.();
    };
    frame.addEventListener("load", listen);
    window.addEventListener("message", onMsg);
    const t = setTimeout(listen, 1500);
    return () => {
      frame.removeEventListener("load", listen);
      window.removeEventListener("message", onMsg);
      clearTimeout(t);
    };
  }, [iframeRef, enabled, frameKey]);
};
